import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";

export const regionFields = `
id
      regionalUniqueId
      reginalName
      reginalPostcode
      napaId
`
export const GET_ALL_REGIONS = gql`
query GetAllRegions {
  getAllRegions {
    ${baseResponseGraphqlField}
    data {
     ${regionFields}
    }
  }
}
`
